import { formatListenedHours, type LiveStatsState } from '../hooks/useLiveStats';

export default function LiveStats({ online, listenedSeconds, connected }: LiveStatsState) {
  return (
    <section className={connected ? 'live-stats connected' : 'live-stats'} aria-label="Live listening statistics">
      <span className="live-stat">
        <i aria-hidden="true" />
        <strong>{online ?? '—'}</strong>
        <small>online</small>
      </span>
      <span className="live-stats-divider" aria-hidden="true" />
      <span className="live-stat">
        <strong>{formatListenedHours(listenedSeconds)}</strong>
        <small>hours listened</small>
      </span>
    </section>
  );
}
